import { CalendarDate } from '@internationalized/date';
import { RangeValue } from '@react-types/shared';
import { ReactNode } from 'react';
import { FormattedDate } from 'react-intl';

import Title from '../../../Title/Title';

import styles from './CalendarHeading.module.css';

type ChildrenProps = {
    month: CalendarDate;
};

type CalendarHeadingProps = {
    visibleRange: RangeValue<CalendarDate>;
    timeZone: string;
    children?: (props: ChildrenProps) => ReactNode;
};

const CalendarHeading = ({
    visibleRange,
    timeZone,
    children,
}: CalendarHeadingProps) => {
    let { start, end } = visibleRange;
    const months: Array<CalendarDate> = [];

    while (start.compare(end) < 0) {
        months.push(start);
        start = start.add({ months: 1 });
    }

    return (
        <div className={styles.Root}>
            {months.map((month) => (
                <div className={styles.Month} key={month.toString()}>
                    <Title lineHeight="small">
                        <FormattedDate
                            value={month.toDate(timeZone)}
                            month="long"
                            year="numeric"
                        />
                    </Title>

                    {children?.({ month })}
                </div>
            ))}
        </div>
    );
};

export default CalendarHeading;
